import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { desktopCSS, mobileCSS, tabletCSS } from '@measures/responsive'

const StyledImageWrapper = styled.div`
  position: relative;
  min-width: 0;

  ${desktopCSS(css`
    width: 100px;
    height: 100px;
  `)}

  ${tabletCSS(css`
    width: 123px;
    height: 123px;
  `)}

  ${mobileCSS(css`
    width: 150px;
    height: 150px;
  `)}
`

type ImageWrapperProps = {
  children?: React.ReactNode
}

const ImageWrapper: FunctionComponent<ImageWrapperProps> = ({ children }) => {
  return <StyledImageWrapper>{children}</StyledImageWrapper>
}

export default ImageWrapper
